<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="container-fluid glb-popup">
  <h2> Admin Dashboard</h2>
  <br>

    <h3>&nbsp;&nbsp; Auto Generate Property Descriptions</h3>
    &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('properties/prop-long-desc/for-all-composite-properties')">Auto Generate Prop Long Description for All Composite</a>
    &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('properties/channel-headline-special-offer/for-all-composite-properties')">Auto Generate Channel Headline Special Offers for All Composite</a>

    <br>
      <br>
        <h3>&nbsp;&nbsp; Cache</h3>
        &nbsp;&nbsp;&nbsp;&nbsp;<button type="button" pButton label="Refresh Fast Search and Short Term Rental Property cache" class="p-button-outlined"
        pTooltip="Refreshes fastSearchCache, shortTermRentalApiCache, and INVOICE_SUBTOTAL_CACHE from DB across all servers."
        tooltipPosition="top"
      (click)="refreshCacheFromDbAndSyncS3()"></button>
      &nbsp;&nbsp;&nbsp;&nbsp;<button type="button" pButton label="Refresh Fast Search cache" class="p-button-outlined"
      pTooltip="Refreshes fastSearchCache and INVOICE_SUBTOTAL_CACHE from DB across all servers."
      tooltipPosition="top"
    (click)="refreshFastSearchCacheFromDbAndSyncS3()"></button>
    &nbsp;&nbsp;&nbsp;&nbsp;<button type="button" pButton label="Refresh Short Term Rental Property cache" class="p-button-outlined"
    pTooltip="Refreshes shortTermRentalApiCache from DB across all servers."
    tooltipPosition="top"
  (click)="refreshShortTermRentalCacheFromDbAndSyncS3()"></button>
  &nbsp;&nbsp;&nbsp;&nbsp;<button type="button" pButton label="Clear In-Memory Cache" class="p-button-outlined"
  pTooltip="Clears fastSearchCache, shortTermRentalApiCache, and INVOICE_SUBTOTAL_CACHE across all servers. Caches will be empty until next rebuild from DB or server restart."
  tooltipPosition="top"
(click)="clearInMemoryCache()"></button>


<br>
  <br>
    <br>
      <h3>&nbsp;&nbsp; Sync SL -> Wiki</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('owner-profiles/streamline/owners')">Sync all SL Owners -> Wiki</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('streamline/properties/sync')">Sync all SL Properties -> Wiki</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('streamline/sync-booking/property/811645')">Sync all SL Reservations-> Wiki</a>
      <br><br>

      <h3>&nbsp;&nbsp; Streamline Price CSV</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('guest-portal/streamline-price-csv')">Streamline Price CSV (Download File)</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="getEndPointResponse('guest-portal/streamline-price')">Streamline Price Text (Text Response)</a>
      <br><br>

      <h3>&nbsp;&nbsp; YieldMax</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="generateRates()">Generate all rates and los and send to wiki</a>
      <br><br>

      <h3>&nbsp;&nbsp; Home Owner Arrival</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a  href="javascript:void(0)" (click)="getEmailReportOfHomeOwnerArrival()">Email Home owner Arrival Report</a>
      <br><br>

      <h3>&nbsp;&nbsp; Breezway</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a  href="javascript:void(0)" (click)="saveAllProperties()">Sync All Properties To Breezway</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="saveAllReservations()">Sync All Resevation To Breezway</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="syncAllTasksToBreezwayLast45Days()">Sync All Task to Breezeway (Last 45 days)</a>
      <br><br>

      <h3>&nbsp;&nbsp; VRBO </h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a  href="javascript:void(0)" (click)="saveAllPropertiesToVrbo()">Sync All Properties To VRBO</a>
      &nbsp;&nbsp;&nbsp;&nbsp;<a  href="javascript:void(0)" (click)="syncLOSAllPropertiesToVrbo()">Sync LOS for All Properties To VRBO</a>
      &nbsp;&nbsp;&nbsp;&nbsp;<a  href="javascript:void(0)" (click)="syncUnitAvailabilityAllPropertiesToVrbo()">Sync Unit Availability for All Properties To VRBO</a>
      <br><br>

      <h3>&nbsp;&nbsp; Properties</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/ru-properties-status-list" target="_blank">RU Properties Status List</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/property-list" target="_blank">Property</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/property-summary-list" target="_blank">Property Summary</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/development-list" target="_blank">Development</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/pictures" target="_blank">Pictures</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/features" target="_blank">Features</a>
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/property-features" target="_blank">Property Features</a>
      <br><br>

      <h3>&nbsp;&nbsp; Reservation</h3>
      &nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservations" target="_blank">Reservations</a>
      <br><br>

    &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="triggerEndPoint('reservation-ledgers/regenerate-all-ledger', 'Re Generate All Ledger',
    'Re Generate All Ledger process started. It will take 2 hours to finish this process. please do not re-trigger this process for next 2 hours.'
    )">Re Generate All Reservation Ledger</a>
    <br><br>

    &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="triggerEndPoint('reservation-ledgers/regenerate-all-ota-ledger', 'Re Generate All OTA Ledger',
    'Re Generate All OTA Ledger process started. It will take 2 hours to finish this process. please do not re-trigger this process for next 2 hours.'
    )">Re Generate All OTA Reservation Ledger</a>

  <br><br>

  &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:void(0)" (click)="triggerEndPoint('reservation-ledgers/regenerate-all-ledger-summery', 'Re Generate All Ledger Summery',
    'Re Generate All Ledger summery process started. It will take 2 hours to finish this process. please do not re-trigger this process for next 2 hours.'
    )">Re Generate All Reservation Ledger Summery</a>
<br><br>
<h3>&nbsp;&nbsp; Reports</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-rev-report" target="_blank">Res Rev Report (Revenue)</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-sales-report" target="_blank">Res Sales Report</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/escrows-report" target="_blank">Escrows Report</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservation-summary-report" target="_blank">Reservation Summary Report</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/payment-summary-report" target="_blank">Payment Summary Report</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-sales-dashboard" target="_blank">Res Sales Dashboard</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-sales-dashboard-by-year" target="_blank">Res Sales By Year Dashboard</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/biz-dev-dashboard" target="_blank">Biz Dev Dashboard</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/occupancy-dashboard" target="_blank">Occupancy Dashboard</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/future-occupancy-dashboard" target="_blank">Future Occupancy Dashboard</a>
<br><br>

<h3>&nbsp;&nbsp; Accounting — External Tools</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://app.qbo.intuit.com" target="_blank">QuickBooks Online</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://hitax.hawaii.gov" target="_blank">Hawaii Tax Online (GET / TAT)</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://tap.utah.gov" target="_blank">Utah TAP (Sales / TA Tax)</a>
<br><br>

<h3>&nbsp;&nbsp; Accounting — QB Sync &amp; Reconciliation</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/qb-sync" target="_blank">QB Sync (Bank Deposits)</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/chart-account-list" target="_blank">Chart of Accounts</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservation-ledger-summary" target="_blank">Reservation Ledger Summary</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservation-ledgers" target="_blank">Reservation Ledgers</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/compare-reservation-ledger" target="_blank">Compare Reservation Ledger</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservation-balance-due" target="_blank">Reservation Balance Due</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/payment-confirm-list" target="_blank">Payment Confirms</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/expense-list" target="_blank">Breezeway Sync (Expenses)</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-master-escrow" target="_blank">Res Master Escrow</a>
<br><br>

<h3>&nbsp;&nbsp; Accounting — Owner Statements</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-statements" target="_blank">Owner Statements</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-stmt-list" target="_blank">Owner Statement List</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-stmt-rez-list" target="_blank">Owner Statement Reservations</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-stmt-exp-list" target="_blank">Owner Statement Expenses</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-stmt-rez-detail-list" target="_blank">Owner Statement Rez Detail</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-stmt-exp-detail-list" target="_blank">Owner Statement Exp Detail</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/owner-statements-reconciliation" target="_blank">Owner Statement Reconciliation</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/statements" target="_blank">Owner Stmt View (PDF)</a>
<br><br>

<h3>&nbsp;&nbsp; Accounting — Financial Reports</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reports-dashboard" target="_blank">Reports Dashboard</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/daily-report" target="_blank">Daily Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-rev-report" target="_blank">Revenue Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/escrows-report" target="_blank">Escrows Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/payment-summary-report" target="_blank">Payment Summary Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/reservation-summary-report" target="_blank">Reservation Summary Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/travel-insurance-report" target="_blank">Travel Insurance Report</a>
<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/res-sales-report" target="_blank">Sales Report</a>
<br><br>

<h3>&nbsp;&nbsp; Others</h3>
&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/review-list" target="_blank">Review</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/quality-test" target="_blank">Quality Test</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/article-list" target="_blank">Article</a>
<br><br>

&nbsp;&nbsp;&nbsp;&nbsp;<a href="{{kbmAdminURL}}/jobs" target="_blank">Jobs</a>
<br><br>
&nbsp;&nbsp;<a href="{{kbmAdminURL}}/quartz-jobs" target="_blank">Jobs</a>
<br><br>

</div>
